import { PremiacaoIsolada, Combo } from 'types/experienceCatalog';
import { api } from './api';
import { IRegulation } from './regulation.service';

export async function fetchExperienceCatalogList(playerId: string, ciclo: string) {
  try {
    const payload = { player: playerId, _id: `experiencias_${playerId}_ciclo_${ciclo}`, ciclo: ciclo };
    const result = await api.put(`database/catalogo_experiencias__c`, payload);
    return result.data;
  } catch (e) {
    throw e;
  }
}

export async function getDeadLineExperienceCatalog() {
  try {
    const result = await api.get(`database/periodo_catalogo__c?strict=true&q=_id:'68891f2529e3975350a6732f'`);
    return result.data[0];
  } catch (e) {
    throw e;
  }
}

export async function purchaseItemExperienceCatalog(item: PremiacaoIsolada | Combo, playerId: string) {
  try {
    const payload = {
      item: item.itemIdPurchase,
      player: playerId,
      extra: item,
    };
    const result = await api.post(`virtualgoods/purchase`, payload);
    return result.data[0];
  } catch (e) {
    throw e;
  }
}

export async function fetchQuestionExperienceCatalog() {
  try {
    const result = await api.get(`database/feedback_questions__c`);
    return result.data;
  } catch (e) {
    throw e;
  }
}

export async function VerifyExperienceCatalogItens(playerId: string) {
  try {
    const result = await api.post(`find/verify_experience_by_catalog`, { player: playerId });
    return result.data[0];
  } catch (e) {
    throw e;
  }
}

export async function loadExperiencePurchase(playerId: string, cicle: string) {
  try {
    const payload = { playerId: playerId, cicleId: cicle };

    const result = await api.post(`find/resgate_experiencias`, payload);

    if (result.data && result.data.length > 0) {
      return result.data[0];
    }

    return null;
  } catch (e) {
    throw e;
  }
}

export async function getRegulationExperienceCatalog() {
  const { data } = await api.get<IRegulation[]>(`database/regulamento_experiencias_livelo__c`, {
    headers: {
      Authorization: 'Basic NjMyYjU2YzE1NDVkZDA3Njc2NjIxNzA5OjYzNGQyN2QwOTI3MWYzMzdiMzlmMTQ1OQ==',
    },
  });
  if (Array.isArray(data)) {
    return data[0] as any;
  } else {
    return null;
  }
}

export const registerFeedbackExperienceCatalog: any = (
  userId: string,
  message: string,
  questions: any[],
  permitidoIdentificar: boolean,
) => {
  return new Promise((resolve, reject) => {
    const questionsList = Object.assign({}, questions);

    const payload = {
      userId,
      message,
      time: { $date: new Date().getTime() },
      questions: questionsList,
      permitidoIdentificar,
    };

    api
      .post('database/feedback_experience_catalog_1s2025__c', payload)
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export const fetchFeedbackExperienceCatalog: any = async (
  userId: string,
) => {
  const { data } = await api.get(`database/feedback_experience_catalog_1s2025__c?q=userId:"${userId}"`);
  if (Array.isArray(data)) {
    return data;
  } else {
    return null;
  }
};
